export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 30,
            staffing: 0.05,
            staffingCode: "da",
            equipment: ['Tabletop Metering Machine'],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 30,
            staffing:0.1,
            staffingCode: "da",
            equipment: ['Tabletop Metering Machine'],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 30,
            staffing: 0.15,
            staffingCode: "da",
            equipment: ['Tabletop Metering Machine'],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 4,200 env per month",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 8,400 env per month",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "up to 12,600 env per month",
                    value: 3
                }
            ]
        }

    ]
}
